import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'
import { canAccessRoute, getDefaultHomePath } from '../utils/routeAccess'

/**
 * Protege el contenido según la matriz ACL (routeAccessMatrix.js).
 * La navegación global ya se filtra en App; esto evita renderizar la página si no hay acceso.
 */
const PermissionRoute = ({
  children,
  redirectTo,
  fallback = null,
}) => {
  const { permissions, isLoading } = usePermissions()
  const { pathname } = useLocation()

  if (isLoading) {
    return fallback || (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '40vh',
        }}
      >
        <p style={{ color: '#94a3b8' }}>Verificando permisos…</p>
      </div>
    )
  }

  if (!permissions) {
    return <Navigate to="/login" replace />
  }

  if (!canAccessRoute(pathname, permissions)) {
    const target = redirectTo || getDefaultHomePath(permissions)
    return <Navigate to={target} replace />
  }

  return children
}

export default PermissionRoute
